{
  "seriousBusiness": {
    "title": "Activité sérieuse",
    "subtitle": "Pour les professionnels exigeants, voici ces boutons. Utilisez-les judicieusement."
  },
  "addFboLabel": "Ajouter un FBO",
  "deleteFboLabel": "Supprimer <u>ce</u> FBO",
  "currentFbos": {
    "title": "FBO actuels",
    "subtitle": "Modifiez le champ de texte pour changer le nom du FBO. Modifiez leur abonnement (accès aux fonctionnalités restreintes) en sélectionnant une option dans le menu déroulant."
  },
  "subscriptionLabel": "Abonnement",
  "subscriptions": {
    "standard": "Standard",
    "autostacking": "Empilement auto",
    "autostackingWithEdit": "Empilement auto avec modif. Hangar/Tarmac",
    "autostackingWithEditAndCopy": "Empilement auto avec modif. et copie Hangar/Tarmac",
    "inactive": "Inactif"
  }
}
